import {Box, Table, TableBody, Typography} from "@mui/material"
import React from "react"

function NoTransactions({children}: {children: React.ReactNode}) {
	return (
		<Table size="small">
			<TableBody>
				<Box display="flex" justifyContent="center" alignItems="center">
					<Typography variant="caption" color="textSecondary">
						{children}
					</Typography>
				</Box>
			</TableBody>
		</Table>
	)
}

export {NoTransactions}
